<template>
  <div class="mb-3">
    <ul class="nav mb-3">
      <li v-if="htWorkData.length != 0" v-for="(htWork, index) in htWorkData" class="li-tab heat-date-tab"
        :class="{ 'heat-date-tab-active': htTabIndex == index }" @click="htTabIndex = index">
        {{ htWork.work_date }}
      </li>
      <li v-else class="li-tab heat-date-tab heat-date-tab-active">-</li>
    </ul>

    <div class="table-responsive heat-table" v-for="(htWork, index) in   htWorkDataRef  "
      :class="{ 'd-none': htTabIndex != index }">
      <table class="table">
        <thead>
          <tr class="heat-tr">
            <td style="
                min-width: 58px;
                width: 58px;
                text-align: right;
                padding-right: 10px;
              ">
              入料區
            </td>
            <td style="min-width: 65px; width: 65px">前清洗區</td>
            <td style="min-width: 270px; width: 270px">淬火區</td>
            <td style="min-width: 65px; width: 65px">後清洗區</td>
            <td style="min-width: 230px; width: 230px">回火區</td>
            <td style="min-width: 40px; width: 40px">收料區</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="6" style="border: none">
              <div style="position: relative; width: 100%; min-width: 1003px">
                <img alt="" style="width: 100%; min-width: 1002px" :src="htWork.heatTreatmentImage" />
                <div style="
                    width: 4rem;
                    height: auto;
                    font-size: 1.5rem;
                    background-color: #646569;
                    color: #fff;
                    border-radius: 5px;
                    position: absolute;
                    top: 60%;
                    left: 20px;
                  ">
                  {{ htWork.device_name }}
                </div>
              </div>
              <div>
                <table class="sensor-table">
                  <tbody>
                    <tr class="sensor-table-row-green">
                      <td style="min-width: 4rem">感測點</td>
                      <td v-for="data in htWork.work_data">
                        {{ data.name }}
                      </td>
                    </tr>
                    <tr class="sensor-table-row-black">
                      <td style="min-width: 4rem">設定值</td>
                      <td v-for="data in htWork.work_data">
                        {{ data.set_value }}
                      </td>
                    </tr>
                    <tr class="sensor-table-row-green">
                      <td style="min-width: 4rem" rowspan="2">首件時間</td>
                      <td v-for="date in htWork.first_date_table" :colspan="date.first_date_colspan">
                        {{ date.first_date }}
                      </td>
                    </tr>
                    <tr class="sensor-table-row-green">
                      <td v-for="data in htWork.work_data">
                        {{ data.first.time }}
                      </td>
                    </tr>
                    <tr class="sensor-table-row-black">
                      <td style="min-width: 4rem">首件實際值</td>
                      <td v-for="(data, index) in htWork.work_data" :class="checkValueClass(index, data, 'first')">
                        {{ data.first.act_val }}
                      </td>
                    </tr>
                    <tr class="sensor-table-row-green">
                      <td style="min-width: 4rem" rowspan="2">末件時間</td>
                      <td v-for="date in htWork.last_date_table" :colspan="date.last_date_colspan">
                        {{ date.last_date }}
                      </td>
                    </tr>
                    <tr class="sensor-table-row-green">
                      <td v-for="data in htWork.work_data">
                        {{ data.last.time }}
                      </td>
                    </tr>
                    <tr class="sensor-table-row-black">
                      <td style="min-width: 4rem">末件實際值</td>
                      <td v-for="(data, index) in htWork.work_data" :class="checkValueClass(index, data, 'last')">
                        {{ data.last.act_val }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div>
                <table class="heat-in-table">
                  <thead>
                    <tr>
                      <td>焠火入料時間</td>
                      <td>回火入料時間</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="htInData in htWork.ht_in_data">
                      <td>
                        <whdHeatProgress :start="htInData.quench_furn_in_time.start"
                          :runTime="htInData.quench_furn_in_time.run_time" :end="htInData.quench_furn_in_time.end">
                        </whdHeatProgress>
                      </td>
                      <td>
                        <whdHeatProgress :start="htInData.tempering_furn_in_time.start"
                          :runTime="htInData.tempering_furn_in_time.run_time"
                          :end="htInData.tempering_furn_in_time.end"></whdHeatProgress>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-flex d-flex-row">
                <button class="heat-button mx-3" @click="passToHtInquire">
                  熱處理參數名細
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <commonModal :modalShow="modalShow" :size="'xl'">
      <template v-slot:modalheader>
        <button type="button" class="close" @click="modalShow = false">
          ×
        </button>
      </template>
      <template v-slot:default>
        <heatTreatmentInquire :inquireData="inquireData" />
      </template>
    </commonModal>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { ref } from "@vue/reactivity";
import whdHeatProgress from "@/components/workOrderHistoryList/whdHeatProgress.vue";
import commonModal from "@/components/commonModal.vue";
import heatTreatmentInquire from "@/components/heatTreatmentInquire.vue";
import { computed, watch } from "@vue/runtime-core";
export default {
  components: {
    whdHeatProgress,
    commonModal,
    heatTreatmentInquire,
  },
  props: {
    htWorkData: {
      type: Array,
      default: [],
    },
  },
  setup(props) {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const sideBar = computed(() => store.getters["sideBarTree/get_sideBar"]);
    const sideBarNote = computed(() => store.getters["sideBarTree/get_sideBarNote"]);
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      set_sideBarSelect: (payload) => {
        store.dispatch("sideBarTree/set_sideBarSelect", payload);
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
    };

    const htTabIndex = ref(0);
    const htWorkDataRef = ref(props.htWorkData);
    const emptyValue = [
      {
        device_name: "-",
        work_date: "-/-",
        first_date_table: [
          {
            first_date: "-",
            first_date_colspan: 19,
          },
        ],
        last_date_table: [
          {
            last_date: "-",
            last_date_colspan: 19,
          },
        ],
        ht_in_data: [
          {
            quench_furn_in_time: {
              start: "-",
              end: "-",
              run_time: "-",
            },
            tempering_furn_in_time: {
              start: "-",
              end: "-",
              run_time: "-",
            },
          },
        ],
        work_data: [
          {
            name: "前清洗",
            sensor_name: "cln_bf_temp",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "烘乾機",
            sensor_name: "dryer_cln_bf_temp",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "淬火1區",
            sensor_name: "quench_furn_temp1",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "淬火2區",
            sensor_name: "quench_furn_temp2",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "碳勢1",
            sensor_name: "cp1",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "淬火3區",
            sensor_name: "quench_furn_temp3",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "淬火4區",
            sensor_name: "quench_furn_temp4",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "淬火5區",
            sensor_name: "quench_furn_temp5",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "碳勢2",
            sensor_name: "cp2",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "淬火6區",
            sensor_name: "quench_furn_temp6",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "淬火槽",
            sensor_name: "quench_tank_temp",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "後清洗",
            sensor_name: "cln_af_temp",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "回火1區",
            sensor_name: "tempering_furn_temp1",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "回火2區",
            sensor_name: "tempering_furn_temp2",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "回火3區",
            sensor_name: "tempering_furn_temp3",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "回火4區",
            sensor_name: "tempering_furn_temp4",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "回火5區",
            sensor_name: "tempering_furn_temp5",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "發黑槽",
            sensor_name: "carb_tank_temp",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
          {
            name: "烘乾機",
            sensor_name: "dryer_temp",
            set_value: "-",
            first: { act_val: "-", date: "-", time: "-" },
            last: { act_val: "-", date: "-", time: "-" },
          },
        ],
      },
    ];

    watch(
      () => props.htWorkData,
      (newValue) => {
        console.log(newValue);
        htWorkDataRef.value = newValue;
        orgHeatData();
      },
      { deep: true }
    );

    //整理顯示資料
    const orgHeatData = () => {
      if (htWorkDataRef.value.length == 0) {
        htWorkDataRef.value = emptyValue;
      }

      //機台圖片
      htWorkDataRef.value.forEach((data, index) => {
        let device_name = data.device_name;
        if (device_name == 'A2' || device_name == 'B2' || device_name == 'C2') {
          data.heatTreatmentImage = require("@/assets/heat-treatment2.png");
        } else if (device_name == 'D2') {
          data.heatTreatmentImage = require("@/assets/heat-treatmentD2.png");
        } else if (device_name == 'A') {
          data.heatTreatmentImage = require("@/assets/heat-treatmentA.png");
        } else if (device_name == 'B') {
          data.heatTreatmentImage = require("@/assets/heat-treatmentB.png");
        } else if (device_name == 'C') {
          data.heatTreatmentImage = require("@/assets/heat-treatmentC.png");
        } else if (device_name == 'D') {
          data.heatTreatmentImage = require("@/assets/heat-treatmentD.png");
        } else if (device_name == 'E') {
          data.heatTreatmentImage = require("@/assets/heat-treatmentE.png");
        } else {
          data.heatTreatmentImage = require("@/assets/heat-treatmentA.png");
        }
        htWorkDataRef.value[index] = data;
      });
    };
    orgHeatData();

    const modalShow = ref(false);
    const inquireData = ref();
    const passToHtInquire = () => {
      if (inquireData.value == null) {
        let params = {};
        let startTime = htWorkDataRef.value[htTabIndex.value].start_time;
        let endTime = htWorkDataRef.value[htTabIndex.value].end_time;
        let device = htWorkDataRef.value[htTabIndex.value].device_name;
        let htProcess = "";
        console.log(sideBarNote.value);
        if (
          sideBarNote.value.elecboard.site["heat"].oper[
            "heatgroup1"
          ].device.indexOf(device) != -1
        ) {
          htProcess = "factory_one-7";
        } else if (
          sideBarNote.value.elecboard.site["heat"].oper[
            "heatgroup2"
          ].device.indexOf(device) != -1
        ) {
          htProcess = "factory_two-7";
        }
        params["webPage"] =
          sideNavPath.value.length != 0
            ? sideNavPath.value[sideNavPath.value.length - 1]
            : null;
        params["user"] = loginData.value.account;
        params["vuePage"] = "statisticalreports";
        params["methods"] = "POST";
        params["whichFunction"] = "heatTreatmentInquire";
        params["deviceID"] = device;
        params["oper"] = htProcess;
        params["startTime"] = startTime;
        params["endTime"] = endTime;
        params["fromWorkOrderHistory"] = true;
        methods.triggerLoadingBar();
        methods.axiosAction(params).then(() => {
          methods.triggerLoadingBar();
          let result = axiosResult.value;
          if (result["Response"] != "ok") {
            methods.setTimeoutAlert(response);
            return;
          }
          if (result["QueryTableData"].length < 1) {
            methods.setTimeoutAlert(response);
            return;
          }

          inquireData.value = result["QueryTableData"];
          modalShow.value = true;
        });
      } else {
        modalShow.value = true;
      }
    };

    const indexRange = [2, 3, 12, 13, 17];
    const isIndexInRange = (index, range) => range.indexOf(index) === -1;
    const isWarning = (data, category) => {
      if (!category) return false;

      const actVal = data[category].act_val;
      if (data.set_value > 100) {
        return data.set_value + 15 < actVal || data.set_value - 15 > actVal;
      } else if (data.set_value < 1) {
        return data.set_value + 0.05 < actVal || data.set_value - 0.05 > actVal;
      } else {
        return data.set_value + 10 < actVal || data.set_value - 10 > actVal;
      }
    };
    const isError = (data, category) => {
      if (!category) return false;

      const actVal = data[category].act_val;
      if (data.set_value > 100) {
        return data.set_value + 30 < actVal || data.set_value - 30 > actVal;
      } else if (data.set_value < 1) {
        return data.set_value + 0.1 < actVal || data.set_value - 0.1 > actVal;
      } else {
        return data.set_value + 20 < actVal || data.set_value - 20 > actVal;
      }
    };
    const checkValueClass = (index, data, category) => {
      if (isIndexInRange(index, indexRange)) {
        if (isError(data, category)) {
          return { 'sensor-table-act-value-error': true };
        } else if (isWarning(data, category)) {
          return { 'sensor-table-act-value-warning': true };
        }
      }
      return {};
    };

    return {
      ...methods,
      htTabIndex,
      htWorkDataRef,
      modalShow,
      passToHtInquire,
      inquireData,
      checkValueClass,
    };
  },
};
</script>

<style scoped>
.li-tab {
  width: 140px;
  margin-right: 0.2rem;
  padding: 0.5rem 1rem 0px;
  background-color: transparent;
  font-size: 1rem;
  font-family: dfyuanstd-w5, dfyuanstd-w3;
  cursor: pointer;
}

.heat-date-tab {
  color: #ff6b00;
  border-bottom: 0.6rem solid #ff6b00;
}

.heat-date-tab-active {
  color: #fff;
  background-color: #ff6b00;
  border-radius: 0.63rem 0.63rem 0 0;
}

.heat-table {
  background-color: #ffffff;
  padding: 0px;
  border-top: 1px solid #646569;
  border-left: 1px solid #646569;
  border-right: 1px solid #646569;
  border-bottom: 1px solid #646569;
}

.heat-tr {
  color: #fff;
  background-color: #646569;
  font-family: dfyuanstd-w7;
  outline: none;
}

.heat-tr>td {
  font-size: 12px;
}

.sensor-table {
  border-collapse: collapse;
  width: 97%;
  margin: 20px auto;
}

.sensor-table td {
  width: 5rem;
  height: 3rem;
  border: 0.5px solid #999;
}

.sensor-table-row-green {
  color: #4b8c80;
  font-size: 12px;
}

.sensor-table-row-black {
  background-color: #f2f2f2;
  color: #212529;
  font-size: 12px;
}

.heat-in-table {
  width: 97%;
  margin: 20px auto;
}

.heat-in-table>thead td {
  color: #000;
  border: 0.5px solid #999;
  background-color: #ccc;
  padding: 0.5rem;
}

.heat-in-table>tbody td {
  border: 0.5px solid #999;
  padding: 0.5rem;
}

.heat-button {
  border: 0px;
  border-radius: 5px;
  background-color: #4b8c80;
  color: #fff;
  padding: 0 13px;
  width: auto;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.125rem;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
  text-align: center;
  margin: 0 0 0 1.5rem;
  cursor: pointer;
  text-decoration: none;
}

.sensor-table-act-value-error {
  background-color: #c10000;
  color: #fff;
}

.sensor-table-act-value-warning {
  background-color: #ffc100;
  color: #646569;
}
</style>
